import { render, staticRenderFns } from "./PhotoAlbum.vue?vue&type=template&id=7f259309&scoped=true&lang=pug"
import script from "./PhotoAlbum.vue?vue&type=script&lang=js"
export * from "./PhotoAlbum.vue?vue&type=script&lang=js"
import style0 from "./PhotoAlbum.vue?vue&type=style&index=0&id=7f259309&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f259309",
  null
  
)

export default component.exports